import {
  ALL_TOURS_LIST_START,
  ALL_TOURS_LIST_SUCCESS,
  ALL_TOURS_LIST_ERROR,
  GET_TOUR_LEAD_LIST_START,
  GET_TOUR_LEAD_LIST_SUCCESS,
  GET_TOUR_LEAD_LIST_ERROR,
  GET_TOUR_DETAILS_START,
  GET_TOUR_DETAILS_SUCCESS,
  GET_TOUR_DETAILS_ERROR,
  ADD_UPDATE_TOURS_START,
  ADD_UPDATE_TOURS_SUCCESS,
  ADD_UPDATE_TOURS_ERROR,
  ADD_TOURS_ASSETS_START,
  ADD_TOURS_ASSETS_SUCCESS,
  ADD_TOURS_ASSETS_ERROR,
  TOUR_SUBMIT_FOR_APPROVAL_START,
  TOUR_SUBMIT_FOR_APPROVAL_SUCCESS,
  TOUR_SUBMIT_FOR_APPROVAL_ERROR,
  TOUR_PENDING_FOR_APPROVAL_START,
  TOUR_PENDING_FOR_APPROVAL_SUCCESS,
  TOUR_PENDING_FOR_APPROVAL_ERROR,
  TOUR_AWAITING_TRIPS_START,
  TOUR_AWAITING_TRIPS_SUCCESS,
  TOUR_AWAITING_TRIPS_ERROR,
  COPY_TRIP_START,
  COPY_TRIP_SUCCESS,
  COPY_TRIP_ERROR,
  REJECT_TRIP_REQUEST,
  REJECT_TRIP_SUCCESS,
  REJECT_TRIP_FAILURE,
} from "../Constant/ManageTourConstant";

const initialState = {
  loading: false,
  allToursList: [],
  tourLeadList: [],
  tourDetails: {},
  assetData: [],
  submiteData: [],
  tourPendingList: [],
  awaitedTripList: [],
  copyTripLoading: false,
  copyTrip: [],
  rejectTripLoading: false,
  rejectTripData: [],
};

export default function ManageToursReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case ALL_TOURS_LIST_START:
    case GET_TOUR_LEAD_LIST_START:
    case GET_TOUR_DETAILS_START:
    case ADD_UPDATE_TOURS_START:
    case ADD_TOURS_ASSETS_START:
    case TOUR_SUBMIT_FOR_APPROVAL_START:
    case TOUR_PENDING_FOR_APPROVAL_START:
    case TOUR_AWAITING_TRIPS_START:
      return {
        ...state,
        loading: true,
      };
    case ALL_TOURS_LIST_SUCCESS:
      return {
        ...state,
        allToursList: action.payload,
        loading: false,
      };
    case GET_TOUR_LEAD_LIST_SUCCESS:
      return {
        ...state,
        tourLeadList: action.payload,
        loading: false,
      };
    case GET_TOUR_DETAILS_SUCCESS:
      return {
        ...state,
        tourDetails: action.payload,
        loading: false,
      };
    case ADD_UPDATE_TOURS_SUCCESS:
      return {
        ...state,
        tourDetails: { ...state.tourDetails, toursDetail: action.payload },
        loading: false,
      };
    case ADD_TOURS_ASSETS_SUCCESS:
      return {
        ...state,
        assetData: action.payload,
        loading: false,
      };
    case TOUR_SUBMIT_FOR_APPROVAL_SUCCESS:
      return {
        ...state,
        submiteData: action.payload,
        loading: false,
      };
    case TOUR_PENDING_FOR_APPROVAL_SUCCESS:
      return {
        ...state,
        tourPendingList: action.payload,
        loading: false,
      };
    case TOUR_AWAITING_TRIPS_SUCCESS:
      return {
        ...state,
        awaitedTripList: action.payload,
        loading: false,
      };
    case ALL_TOURS_LIST_ERROR:
    case GET_TOUR_LEAD_LIST_ERROR:
    case GET_TOUR_DETAILS_ERROR:
    case GET_TOUR_DETAILS_ERROR:
    case GET_TOUR_DETAILS_ERROR:
    case ADD_UPDATE_TOURS_ERROR:
    case ADD_TOURS_ASSETS_ERROR:
    case TOUR_SUBMIT_FOR_APPROVAL_ERROR:
    case TOUR_PENDING_FOR_APPROVAL_ERROR:
      return {
        ...state,
        tourLeadList: [],
        loading: false,
        message: action.error.message,
      };
    case TOUR_AWAITING_TRIPS_ERROR:
      return {
        ...state,
        awaitedTripList: [],
        loading: false,
        message: action.error.message,
      };
    case COPY_TRIP_START:
      return {
        ...state,
        copyTripLoading: true,
      };
    case COPY_TRIP_SUCCESS:
      return {
        ...state,
        copyTripLoading: false,
        copyTrip: action.payload,
      };
    case COPY_TRIP_ERROR:
      return {
        ...state,
        copyTripLoading: false,
      };
    case REJECT_TRIP_REQUEST:
      return {
        ...state,
        rejectTripLoading: true,
      };
    case REJECT_TRIP_SUCCESS:
      return {
        ...state,
        rejectTripLoading: false,
        rejectTripData: action.payload,
      };
    case REJECT_TRIP_FAILURE:
      return {
        ...state,
        rejectTripLoading: false,
      };
    default:
      return state;
  }
}
